import { render, staticRenderFns } from "./company-member.vue?vue&type=template&id=5ff5c4f2&scoped=true"
import script from "./company-member.vue?vue&type=script&lang=js"
export * from "./company-member.vue?vue&type=script&lang=js"
import style0 from "./company-member.vue?vue&type=style&index=0&id=5ff5c4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5c4f2",
  null
  
)

export default component.exports